import { Box, Container, Grid, Card, CardContent, Typography, Button, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';

const Package = ({ title, price, features, totalValue, ctaLink, ctaText }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5 }}
  >
    <Card 
      elevation={3}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        '&:hover': {
          transform: 'translateY(-8px)',
          transition: 'transform 0.3s ease-in-out',
        },
      }}
    >
      <CardContent sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h5" component="h3" gutterBottom align="center" sx={{ fontWeight: 'bold' }}>
          {title}
        </Typography>
        <Typography variant="h4" component="div" align="center" sx={{ my: 2, color: 'primary.main' }}>
          ${price}
        </Typography>
        <List>
          {features.map((feature, index) => (
            <ListItem key={index} sx={{ py: 1 }}>
              <ListItemIcon>
                <CheckIcon color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary={feature}
                primaryTypographyProps={{
                  sx: { fontSize: '0.95rem' }
                }}
              />
            </ListItem>
          ))}
        </List>
        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <p>
            {totalValue && (
              <Typography variant="body2" sx={{ mb: 1 , fontSize: '2.0rem'}}>
                Total Value: {totalValue}
              </Typography>
            )}
          </p>
          <a href={ctaLink} style={{color: 'inherit', textDecoration: 'none'}} target="_blank" rel="noopener noreferrer">
            <Button 
              variant="contained" 
              color="primary" 
              size="large"
              sx={{ 
                px: 4,
                py: 1.5,
                fontWeight: 'bold',
                '&:hover': {
                  transform: 'scale(1.05)',
                  transition: 'transform 0.2s ease-in-out',
                }
              }}
            >
                {ctaText}
            </Button>
          </a>
        </Box>
      </CardContent>
    </Card>
  </motion.div>
);

const Packages = () => {
  const packages = [
    {
      title: 'The Start-Up Package',
      price: '495',
      features: [
        '3 Hours Of One-On-One Coaching ($300 Value)',
        'Business Setup Checklist ($250 Value)',
        'Client Onboarding Templates ($150 Value)',
        'Essential Tax Prep Software Recommendations ($50 Value)',
        'Tips On Business Structure And Best Practices ($250 Value)',
        'Marketing Basics ($125 Value)',
        'Email Support For 12 Months ($600 Value)',
      ],
      totalValue: '$1,725',
      ctaText: 'Get Started Now for $495!',
      ctaLink: 'https://square.link/u/i7fWrZGk'
    },
    {
      title: 'The Business Package',
      price: '1,995',
      features: [
        '5 Hours Of One-On-One Coaching ($500 Value)',
        'Business Setup Checklist ($250 Value)',
        'Client Onboarding Templates ($150 Value)',
        'Essential Tax Prep Software Recommendations ($50 Value)',
        'Tips On Business Structure and Best Practices ($250 Value)',
        'Advanced Marketing Strategies ($250 Value)',
        'Priority Email Support For 12 months ($900 Value)',
        'FREE Tax Business Website Setup ($5,000 Value)',
        'FREE SEO Optimization Strategies ($500 Value)',
        'FREE Facebook/LinkedIn Ad Campaign Setup ($1,500 Value)',
        'FREE Sales Script Templates ($500 Value)',
        'FREE Professional Tax Business Logo Design ($500 Value)',
        'FREE AI Playbook To Grow Your Tax Business ($500 Value)',
        // 'Access to exclusive Discord group',
      ],
      totalValue: '$10,850',
      ctaText: 'Scale Your Business Now for $1,995!',
      ctaLink: 'https://square.link/u/Hm586voQ'
    }
  ];

  return (
    <Box id="packages" sx={{ py: 8, bgcolor: 'white' }}>
      <Container maxWidth="lg">
        <Typography
          component="h2"
          variant="h3"
          align="center"
          color="text.primary"
          gutterBottom
          sx={{ mb: 6 }}
        >
          Which Package Fits Your Needs?
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {packages.map((pkg, index) => (
            <Grid item key={index} xs={12} md={6}>
              <Package {...pkg} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Packages;
